import produce from 'immer';
import {
  FAILURE,
  fulfilled,
  IDLE,
  idle,
  pending,
  rejected,
  REQUEST,
  SUCCESS,
} from 'src/redux/constants';
import { UNLOAD_SURVEY } from './constants';
import {
  UnloadSurveyError,
  UnloadSurveyDataActionTypes,
  UnloadSurveyState,
} from './types';

const initialState: UnloadSurveyState = {
  status: idle,
  entities: {},
  error: null,
};

export default produce(
  (
    draft = initialState,
    action: UnloadSurveyDataActionTypes,
  ): UnloadSurveyState => {
    switch (action.type) {
      case UNLOAD_SURVEY + REQUEST: {
        draft.status = pending;
        draft.error = null;
        break;
      }
      case UNLOAD_SURVEY + SUCCESS: {
        draft.status = fulfilled;
        break;
      }
      case UNLOAD_SURVEY + FAILURE: {
        draft.status = rejected;
        draft.error = (action as UnloadSurveyError).error;
        break;
      }
      case UNLOAD_SURVEY + IDLE: {
        draft.status = idle;
        break;
      }
      default:
        return draft;
    }
  },
);
